import { createSelector } from '@ngrx/store';
import { getNewModifyOrderState } from '../reducers';

export const getModifyReasonCode = createSelector(
  getNewModifyOrderState,
  (state) => state.modifyReason.modifyReasonCode,
);

export const getModifyReasonComment = createSelector(
  getNewModifyOrderState,
  (state) => state.modifyReason.modifyReasonComment,
);

export const getModifyReason = createSelector(
  getModifyReasonCode,
  getModifyReasonComment,
  (reasonCode, reasonComment) => {
    return { reasonCode, reasonComment };
  },
);
